export default __webpack_public_path__ + "static/media/blue-streak-tree.77a325d2.svg";